import { useMutation, useQuery } from '@tanstack/react-query';

import { type ChatHistory, type ChatSession, CoblinatorRequester, type FeedbackOption, type PromptRequest } from '@cobliteam/api-lib';

import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();
const requester = new CoblinatorRequester({
  host: env.apiHost,
});

const QUERY_KEY = 'COBLINATOR';

const useRequestResponse = () =>
  useMutation<ChatHistory, unknown, { request: PromptRequest }>({
    mutationFn: (variables) => requester.requestResponse(variables.request),
  });

const useGetChatHistory = () =>
  useQuery<ChatSession[]>({
    queryKey: [QUERY_KEY, 'CHAT_HISTORY'],
    queryFn: () => requester.getChatHistory(),
  });

const useGiveChatFeedback = () =>
  useMutation<ChatHistory, unknown, { chatHistoryId: number; feedback: FeedbackOption }>({
    mutationFn: (variables) => requester.giveFeedback(variables.chatHistoryId, variables.feedback),
  });

export { useRequestResponse, useGetChatHistory, useGiveChatFeedback };
